import { GUEST_ROLE, REMEMBER_ME } from "@constants";
import { createAction, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

const loginSlice = createSlice({
  name: "login",
  initialState: {
    isAuth: Cookies.get(process.env.REACT_APP_USER_TOKEN) ? true : false,
    role: Cookies.get(process.env.REACT_APP_USER_ROLE) || GUEST_ROLE,
    processing: false,
    isFailed: null,
    isExternal: null,
    isBlocked: null,
  },
  reducers: {
    pending(state) {
      state.processing = true;
    },
    success(state, action) {
      const { data, loginInfo } = action.payload;
      const { accessToken, refreshToken } = data.token;
      const { isRemember } = loginInfo;

      if (isRemember) {
        Cookies.set(REMEMBER_ME, JSON.stringify(loginInfo), {
          expires: 365,
        });
      } else Cookies.remove(REMEMBER_ME);

      const role =
        jwtDecode(accessToken)[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ];
      Cookies.set(process.env.REACT_APP_USER_TOKEN, accessToken);
      Cookies.set(process.env.REACT_APP_REFRESH_TOKEN, refreshToken);
      Cookies.set(process.env.REACT_APP_USER_ROLE, role);

      state.isAuth = true;
      state.role = role;
      state.isFailed = false;
      state.processing = false;
      state.isExternal = false;
    },
    failure(state, action) {
      const { statusCode } = action.payload;
      switch (statusCode) {
        case "Authentication failed. Wrong user name or password.":
          state.isBlocked = false;
          break;
        case "Authentication failed. Account has been blocked.":
          state.isBlocked = true;
          break;
        default:
          break;
      }
      state.isFailed = true;
      state.processing = false;
    },
    externalLogin(state, action) {
      const { data } = action.payload;
      const { accessToken, refreshToken } = data.token;

      const role =
        jwtDecode(accessToken)[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ];
      Cookies.set(process.env.REACT_APP_USER_TOKEN, accessToken);
      Cookies.set(process.env.REACT_APP_REFRESH_TOKEN, refreshToken);
      Cookies.set(process.env.REACT_APP_USER_ROLE, role);

      state.isAuth = true;
      state.role = role;
      state.isFailed = false;
      state.processing = false;
      state.isExternal = true;
    },
    logout(state) {
      state.isAuth = false;
      state.role = GUEST_ROLE;
      state.isExternal = null;
      Cookies.remove(process.env.REACT_APP_USER_TOKEN);
      Cookies.remove(process.env.REACT_APP_REFRESH_TOKEN);
      Cookies.remove(process.env.REACT_APP_USER_ROLE);
    },
  },
});

const { name, actions, reducer } = loginSlice;
const loginAction = createAction(name);
const externalLoginSuccessAction = actions.externalLogin;
const logoutAction = actions.logout;

export {
  loginAction,
  externalLoginSuccessAction,
  logoutAction,
  actions as loginActions,
  reducer as loginReducer,
};
